//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Whitelabel',

  data() {
    return {
      error: null,
      warning: null,
      pageState: null,
      loading: false,
      pageLoading: false,
      cohort: null,
      isUser: false,
      isCohortMember: false,
      password: '',
      permission: null,
      permissions: null,
      authenticated: false,
      permissionLevels: [
        {
          title: 'NONE – Stop Sharing Data',
          description: 'Your permission to share data is immediately revoked.',
        },
        {
          title: 'Aggregate Data, Anonymous',
          description:
            'Your data and information may only be shared in aggregate, meaning that you will be one of many anonymous individuals contributing to a metric that is calculated across the entire group. None of your individual workouts are shared - only aggregate metrics that combine your data along with similar data provided by others.',
        },
        {
          title: 'Individual Data, De-identified',
          description:
            'Your wearables data may be shared, though the most sensitive & personally identifiable information will not be shared. Exact GPS coordinates from workouts are withheld, as are exact birthdate, your name, and your contact information (email address). Individual workouts may be shared, but you will not be personally identified.',
        },
        {
          title: 'Individual Data, Identified',
          description:
            'This is the most inclusive set of permissions. Your wearables data may be shared, including exact GPS coordinates in recorded workouts. Personal and identifiable information including your name, birthdate, and contact information (email address) may also be shared.',
        },
      ],
    };
  },

  async created() {
    this.permissions = this.$route.meta.permissions;
    this.permission = this.$route.meta.permission;
  },

  async mounted() {
    if (
      this.userEmail.includes('Invalid') ||
      this.userEmail.includes('not provided')
    ) { this.error = this.userEmail; }
    if (!this.error) {
      await this.mountUserAndCohort();
    }
  },

  methods: {
    ...mapActions(['initialize', 'register', 'authenticate']),

    async login() {
      try {
        this.loading = true;
        this.pageState = 'Initializing Connections Dashboard...';
        const data = await this.authenticate({
          email: this.userEmail,
          password: this.password.trim(),
        });
        if (data.member && data.member.member_id) {
          this.authenticated = true;
        }

        if (!this.isCohortMember) {
          await this.addUserToCohort();
        }

        this.$router.push({
          name: 'RHFConnections',
        });
      } catch (error) {
        const { response } = error;
        if (response.data.includes('Incorrect username or password.')) {
          this.warning = 'Incorrect password.';
        } else if (response.data.includes('Password attempts exceeded')) {
          this.warning = 'Too many login attempts, please try again later.';
        } else {
          this.error = error;
        }
        this.loading = false;
        this.pageState = null;
        setTimeout(this.setWarning, 3000);
      }
    },

    setWarning(value = null) {
      this.warning = value;
    },

    async mountUserAndCohort() {
      this.pageLoading = true;
      try {
        const { data } = await this.$api.checkIfCohortMember(
          this.userEmail,
          this.cohortId,
        );
        this.isUser = true;
        this.isCohortMember = data;
      } catch (error) {
        if (error instanceof String && error.includes('not found')) { this.isUser = false; }
      } finally {
        this.pageLoading = false;
        if (this.isUser && this.isCohortMember && this.loggedInMember) {
          this.$router.push({
            name: 'RHFConnections',
          });
        }
      }
    },

    async getCohort() {
      try {
        this.cohort = await this.$api.getCohort(this.cohortId);
      } catch (error) {
        this.error = error;
      }
    },

    async registerUser() {
      try {
        this.loading = true;
        this.pageState = 'Authorizing connection...';
        await this.register({
          email: this.userEmail,
          password: this.password,
          coupon: this.$route.meta.couponCode,
        });
        await this.addUserToCohort();
        this.pageState = 'Initializing Connections Dashboard...';
        const data = await this.authenticate({
          email: this.userEmail,
          password: this.password.trim(),
        });
        if (data.member && data.member.member_id) {
          this.authenticated = true;
        }
        this.pageState = 'Success ...';
        this.isUser = true;
        this.isCohortMember = true;
        this.authenticated = true;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
        this.pageState = null;
        this.$router.push({
          name: 'RHFConnections',
        });
      }
    },

    async addUserToCohort() {
      try {
        this.pageState = `Syncing to ${this.cohortName} ...`;
        await this.$container.dao.addUserToCohort(
          this.loggedInMember.memberId,
          this.cohortId,
          this.permission,
        );
      } catch (error) {
        this.error = error;
      } finally {
        this.pageState = null;
      }
    },

    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
  },

  computed: {
    ...mapGetters(['user', 'loggedInMember', 'isAuthenticated']),

    userEmail() {
      if (this.$route.query && this.$route.query.e) {
        const email = atob(this.$route.query.e);
        if (!this.validateEmail(email)) return 'Invalid email.';
        return email;
      }
      return 'Email not provided.';
    },

    cohortId() {
      return this.$route.meta.cohortId;
    },

    cohortName() {
      return this.$route.meta.name;
    },

    cohortUrl() {
      return this.$route.meta.url;
    },

    validatePassword() {
      const validations = {
        min: value => value.length >= 8 ||
          'Password length must be at least 8 characteres.',
        capital: value => /[A-Z]+/.test(value) ||
          'Password must have at least one uppercase letter.',
        lower: value => /[a-z]+/.test(value) ||
          'Password must have at least one lowercase letter.',
        number: value => /[0-9]+/.test(value) || 'Password must have at least one number.',
        symbol: value => /[#@!$%^&*()_|~`{}[\]:";'<>?,./]+/.test(value) ||
          "Password must have at least 1 of the following symbols ^ $ * . [ ] { } ( ) ? \" ! @ # % & / , > < ' : ; | _ ~ `.",
      };

      if (!this.password || this.password.length === 0) return [];

      const ret = Object.entries(validations)
        .map(
          // eslint-disable-next-line no-unused-vars
          ([_, func]) => `${func(this.password)}`,
        )
        .filter(value => value !== 'true');
      return ret;
    },

    disabled() {
      return !this.permission || !(this.validatePassword.length === 0);
    },
  },
};
